export default __webpack_public_path__ + "static/media/banner.56ba1e77.png";